export const FETCH_LOADING = 'loading/FETCH_LOADING'



// WEBPACK FOOTER //
// ./src/vuex/modules/loading/types.js